import { getTransactionStatus } from '../../utils/getTransactionStatus';
import cn from '@/utils/cn';

const OutlineClass = cn(['outline', 'rounded-full', 'relative', 'h-8', 'w-8']);

export const getStyle = (state: ReturnType<typeof getTransactionStatus>) => {
  switch (state) {
    case 'pending':
      return cn(OutlineClass, 'outline-aux-wizardwhite');
    case 'declined':
      return cn(OutlineClass, 'outline-error-darkred');
    case 'completed':
      return cn(OutlineClass, 'outline-emerge-teal');
  }
};
